import React,  { useState } from 'react';
import {Modal, Form, Button, ButtonGroup, ToggleButton} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

// A számlázási adatok (vevo) megadása. Fizetős jegynél kötelező; a magánszemély/cég választás
// nincs előre kiválasztva (null), a kitöltés előtt választani kell.
// Props: vevo (a mentett számlázási adatok vagy null), teljes (a mentett adatok teljesek-e),
//        alapNev (a felhasználó neve, a magánszemély neve mező előtöltéséhez), onSave(felhasznalo), onHide
export default function ModalSzamlazasiAdatok({vevo, teljes, alapNev, onSave, onHide, ...props}) {
    const [szemelyNev, setSzemelyNev] = useState('');
    const [ceg, setCeg] = useState(null);   // null: még nem választott; 0: magánszemély; 1: cég
    const [cegNev, setCegNev] = useState('');
    const [telepules, setTelepules] = useState('');
    const [irsz, setIrsz] = useState('');
    const [cim, setCim] = useState('');
    const [adoszam, setAdoszam] = useState('');
    const [kellValidalas, setKellValidalas] = useState(false);

    function onShow(){
        setKellValidalas(false);
        if (vevo) {
            setSzemelyNev(vevo.Szemelynev || alapNev || '')
            // a már teljes adat típusát megtartjuk; a hiányos (régi) adatnál újra választani kell
            setCeg(teljes ? (vevo.Ceg ? 1 : 0) : null)
            setCegNev(vevo.Cegnev || '')
            setTelepules(vevo.Telepules || '')
            setIrsz(vevo.Irsz || '')
            setCim(vevo.Cim || '')
            setAdoszam(vevo.Adoszam || '')
        } else {
            setSzemelyNev(alapNev || '')
            setCeg(null)
            setCegNev('')
            setTelepules('')
            setIrsz('')
            setCim('')
            setAdoszam('')
        }
    }

    function hianyzoMezo(){
        if (ceg === null) { return true; }
        if (ceg === 1) {
            if (cegNev.trim() === '' || adoszam.trim() === '') { return true; }
        } else {
            if (szemelyNev.trim() === '') { return true; }
        }
        return irsz.trim() === '' || telepules.trim() === '' || cim.trim() === '';
    }

    function onSave_inside(){
        if (hianyzoMezo()) {
            setKellValidalas(true);
            return;
        }
        var szamlazasiAdatok = {
            Ceg: ceg,
            Szemelynev: szemelyNev,
            Cegnev: cegNev,
            Adoszam: adoszam,
            Irsz: irsz,
            Telepules: telepules,
            Cim: cim
        };

        props.callAPI("General.saveSzamlazasiAdatok", {szamlazasiAdatok: szamlazasiAdatok}, function(resp){
            onSave(resp.data.felhasznalo);
        });
    }

    function onSubmitPreventer(event){ event.preventDefault()};

    function ures(ertek){ return kellValidalas && String(ertek).trim() === ''; }

    return(
        <Modal dialogClassName='modalSzamlazasiAdatok' contentClassName='contentSzamlazasiAdatok' onEntered={onShow}
        onHide={onHide} {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
            Számlázási adatok
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>
                Iskolánk alapítványa számlát állít ki a befizetett összegről.
                Kérjük, válassza ki, hogy magánszemélyként vagy cégként kéri a számlát!
            </p>
            <Form noValidate onSubmit={onSubmitPreventer} >
                <ButtonGroup>
                    <ToggleButton
                        type="radio" variant={ceg === 0 ? 'success' : 'outline-success'}
                        name="radio" value={0} id="ceg-magan"
                        checked={ceg === 0} onChange={() => setCeg(0)}
                    >Magánszemély</ToggleButton>
                    <ToggleButton
                        type="radio" variant={ceg === 1 ? 'success' : 'outline-success'}
                        name="radio" value={1} id="ceg-ceg"
                        checked={ceg === 1} onChange={() => setCeg(1)}
                    >Cég</ToggleButton>
                </ButtonGroup>
                {kellValidalas && ceg === null ?
                    <div className="text-danger">Kérjük, válasszon!</div>
                    : undefined
                }
                <br /><br />
                {ceg === null ? undefined :
                <div>
                {ceg === 0 ?
                    <Form.Group className="mb-3" controlId="form_szemelynev">
                        <Form.Label>Név a számlán</Form.Label>
                        <Form.Control type="text" placeholder="Név" value={szemelyNev} required maxLength={50} isInvalid={ures(szemelyNev)} onChange={e => setSzemelyNev(e.target.value)}/>
                        <Form.Control.Feedback type="invalid">A nevet kötelező megadni.</Form.Control.Feedback>
                    </Form.Group>
                    :
                    <div>
                        <Form.Group className="mb-3" controlId="form_cegnev">
                            <Form.Label>Cégnév</Form.Label>
                            <Form.Control type="text" placeholder="A cég neve" value={cegNev} required maxLength={80} isInvalid={ures(cegNev)} onChange={e => setCegNev(e.target.value)}/>
                            <Form.Control.Feedback type="invalid">A cég nevét kötelező megadni.</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="form_adoszam">
                            <Form.Label>Adószám</Form.Label>
                            <Form.Control type="text" placeholder="A cég adószáma" value={adoszam} required maxLength={20} isInvalid={ures(adoszam)} onChange={e => setAdoszam(e.target.value)}/>
                            <Form.Control.Feedback type="invalid">A cég adószámát kötelező megadni.</Form.Control.Feedback>
                        </Form.Group>
                    </div>
                }

                    <div className="cimTitle">{ceg === 1 ? "A cég telephelye" : "Lakcím"}</div>

                    <Form.Group className="mb-3" controlId="form_irsz">
                        <Form.Label>Irányítószám</Form.Label>
                        <Form.Control type="text" placeholder="Irányítószám" value={irsz} required maxLength={10} isInvalid={ures(irsz)} onChange={e => setIrsz(e.target.value)}/>
                        <Form.Control.Feedback type="invalid">Az irányítószámot kötelező megadni.</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="form_telepules">
                        <Form.Label>Település</Form.Label>
                        <Form.Control type="text" placeholder="Település" value={telepules} required maxLength={50} isInvalid={ures(telepules)} onChange={e => setTelepules(e.target.value)}/>
                        <Form.Control.Feedback type="invalid">A település nevét kötelező megadni.</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="form_cim">
                        <Form.Label>Közterület neve, házszám</Form.Label>
                        <Form.Control type="text" placeholder="Közterület, házszám" value={cim} required maxLength={100} isInvalid={ures(cim)} onChange={e => setCim(e.target.value)}/>
                        <Form.Control.Feedback type="invalid">A közterület nevét és a házszámot kötelező megadni.</Form.Control.Feedback>
                    </Form.Group>
                </div>
                }
            </Form>
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={onSave_inside}>Mentés</Button>
            &nbsp;
            <Button variant="default" onClick={onHide}>Mégse</Button>
        </Modal.Footer>
        </Modal>
    )
}
